export type RecordWorkspaceLayout = {
  fullCreate: boolean;
  showList: boolean;
  split: boolean;
};

export function recordLabel(title: string): string {
  const label = title.toLowerCase();
  if (label === 'people') return 'person';
  if (label.startsWith('payments ')) return `payment ${label.slice('payments '.length)}`;
  if (label.endsWith('ies')) return `${label.slice(0, -3)}y`;
  if (label.endsWith('s')) return label.slice(0, -1);
  return label;
}

export function recordWorkspaceLayout(panel: boolean, formOpen: boolean, isNew: boolean): RecordWorkspaceLayout {
  const fullCreate = panel && formOpen && isNew;
  return {
    fullCreate,
    showList: !fullCreate,
    split: panel && formOpen && !isNew,
  };
}
